// components/profesionales/CiudadesOperacion/MapaCoberturaCiudades.js
import React from 'react'
import GoogleMapReact from 'google-map-react'
import { Alert } from 'react-bootstrap'

const MapaCoberturaCiudades = ({ ciudades }) => {
	const GOOGLE_MAPS_API_KEY = 'AIzaSyCaw8ahy7ztFKt6aq9kbqVlM1Bk_YmUU9s'

	// Verificar si hay ciudades con polígonos
	const ciudadesConPoligono = ciudades.filter(ciudad => ciudad.poligono && ciudad.poligono.length > 0)

	if (ciudadesConPoligono.length === 0) {
		return (
			<Alert variant="info">
				No hay información de cobertura geográfica disponible para estas ciudades
			</Alert>
		)
	}

	// Calcular el centro inicial (usamos la primera ciudad con polígono)
	const primeraCiudad = ciudadesConPoligono[0]
	const primerPunto = primeraCiudad.poligono[0]

	const center = {
		lat: Number(primerPunto.lat),
		lng: Number(primerPunto.lon || primerPunto.lng) // Manejar ambos formatos posibles
	}

	// Función para convertir un color hexadecimal a componentes RGB
	const hexToRgb = (hex) => {
		// Eliminar el # si está presente
		hex = hex.replace(/^#/, '')

		// Comprobar si es un formato válido (3 o 6 caracteres)
		const match = hex.match(/[0-9A-Fa-f]{6}|[0-9A-Fa-f]{3}/);
		if (!match) {
			return [0, 0, 0]; // Color negro por defecto si hay un error
		}

		// Convertir a componentes RGB
		try {
			let bigint = parseInt(hex, 16)
			let r = (bigint >> 16) & 255
			let g = (bigint >> 8) & 255
			let b = bigint & 255
			return [r, g, b]
		} catch (error) {
			console.warn('Error al convertir color:', error)
			return [0, 0, 0] // Color negro por defecto si hay un error
		}
	}

	// Renderizar polígonos y marcadores
	const renderMapElements = (map, maps) => {
		// Array para almacenar todos los límites para ajustar el zoom
		const bounds = new maps.LatLngBounds()

		// Para cada ciudad con polígono
		ciudadesConPoligono.forEach(ciudad => {
			// Simplificar polígonos muy grandes para mejor rendimiento
			const puntosPoligono = ciudad.poligono.length > 500
				? ciudad.poligono.filter((_, i) => i % Math.ceil(ciudad.poligono.length / 200) === 0)
				: ciudad.poligono

			// Convertir puntos al formato de Google Maps
			const paths = puntosPoligono.map(punto => {
				const lat = Number(punto.lat)
				const lng = Number(punto.lon || punto.lng) // Manejar ambos formatos posibles

				// Añadir este punto a los límites
				bounds.extend(new maps.LatLng(lat, lng))

				return { lat, lng }
			})

			// Seleccionar color para este polígono
			let strokeColor = ciudad.color || "#FF0000"

			// Convertir color a RGBA para transparencia en el relleno
			let rgbFill = hexToRgb(ciudad.color || "#FF0000")
			let fillColor = `rgba(${rgbFill[0]},${rgbFill[1]},${rgbFill[2]},0.35)`

			// Crear el polígono
			const polygon = new maps.Polygon({
				paths: paths,
				strokeColor: strokeColor,
				strokeOpacity: 0.8,
				strokeWeight: 2,
				fillColor: fillColor,
				fillOpacity: 0.35,
				map: map
			})

			// Agregar un tooltip con el nombre de la ciudad
			const infoWindow = new maps.InfoWindow({
				content: `<div><strong>${ciudad.nombre}</strong><br/>${ciudad.departamento || ''}</div>`
			})

			// Agregar evento para mostrar el tooltip al hacer click
			maps.event.addListener(polygon, 'click', (event) => {
				infoWindow.setPosition(event.latLng)
				infoWindow.open(map)
			})
		})

		// Ajustar el mapa para mostrar todos los polígonos
		map.fitBounds(bounds)
	}

	return (
		<div style={{ minHeight: 400, height: 400, width: '100%' }}>
			<GoogleMapReact
				bootstrapURLKeys={{ key: GOOGLE_MAPS_API_KEY }}
				defaultCenter={center}
				defaultZoom={10}
				onGoogleApiLoaded={({ map, maps }) => renderMapElements(map, maps)}
				yesIWantToUseGoogleMapApiInternals
			>
			</GoogleMapReact>
		</div>
	)
}

export default MapaCoberturaCiudades